import React, { useState } from "react";

const Faqpage = () => {
  const [openSection, setOpenSection] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");


  const faqData = [
    {
      title: "What courses does BrainboxStudy offer?",
      content:
        "We offer a wide range of IT courses, including FullStack Development, Web Designing, AI, Python, and more.",
    },
    {
      title: "Are the courses self-paced or live?",
      content:
        "Most of our courses are self-paced, allowing you to learn at your convenience. Some may include live sessions for added interaction.",
    },
    {
      title: "Will I receive a certificate after completing a course?",
      content:
        "Yes, you will receive a verified certificate upon successfully completing any course.",
    },
    {
      title: "Can I access the courses on mobile devices?",
      content:
        "Absolutely! Our platform is mobile-friendly, so you can learn anytime, anywhere.",
    },
    // {
    //   title: "What payment options are available?",
    //   content:"We accept various payment methods, including credit/debit cards, PayPal, and more, depending on your location."
    // },
    
  ];




  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const filteredFaqData = faqData.filter((faq) =>
    faq.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    faq.content.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="2xl:container 2xl:mx-auto md:py-12 lg:px-20 md:px-6 py-9 px-4">
      <h2 className="font-semibold  lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-gray-800">
        Frequently Asked Questions
      </h2>
      <div className="mt-4 flex md:justify-between md:items-start md:flex-row flex-col justify-start items-start">
        <div>
          <p className="font-normal  text-base leading-6 text-gray-600 lg:w-8/12 md:w-9/12">
          Find quick solutions to the most common queries about our courses, enrollment process, and more.
          </p>
        </div>

        <div className="border-b-2 border-gray-200 pb-2 flex justify-center items-center md:mt-0 mt-10 md:w-auto w-full">
          <input
            placeholder="Search"
            type="text"
            aria-label="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="dark:bg-transparent dark:text-gray-400 dark:placeholder-gray-400 lg:w-96 md:w-72 w-full focus:outline-none placeholder-gray-600 text-base font-normal text-gray-600 leading-4"
          />
          <img
            className="cursor-pointer dark:hidden"
            src="https://tuk-cdn.s3.amazonaws.com/can-uploader/ecom-faq-1-svg1.svg"
            alt="search"
          />
          <img
            className="cursor-pointer hidden dark:block"
            src="https://tuk-cdn.s3.amazonaws.com/can-uploader/ecom-faq-1-svg1dark.svg"
            alt="search"
          />
        </div>
      </div>

      <div className="flex md:flex-row flex-col md:space-x-8 md:mt-12 mt-8">
        <div className="md:w-5/12 lg:w-4/12 w-full rounded-lg">
          <img
            src="https://img.freepik.com/free-photo/everything-will-be-awesome-group-young-people-casual-clothes-working-modern-office_146671-16522.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid"
            alt="Learning in Brain Box Study"
            className="w-full md:block hidden rounded-lg"
          />
          <img
            src="https://img.freepik.com/free-photo/everything-will-be-awesome-group-young-people-casual-clothes-working-modern-office_146671-16522.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid"
            alt="Learning in Brain Box Study"
            className="w-full md:hidden block"
          />
        </div>

        <div className="md:w-7/12 lg:w-8/12 w-full md:mt-0 sm:mt-14 mt-10">
          {/* FAQ Sections */}
          {filteredFaqData.length > 0 ? (
            filteredFaqData.map((faq, index) => (
              <div key={index}>
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => toggleSection(index)}
                >
                  <h3 className="font-semibold text-lg  leading-5 text-gray-800">
                    {faq.title}
                  </h3>
                  <button
                    aria-label="toggle"
                    className="text-gray-800  cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 4.1665V15.8332"
                        stroke="currentColor"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={openSection === index ? "hidden" : "block"}
                      />
                      <path
                        d="M4.16602 10H15.8327"
                        stroke="currentColor"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                {openSection === index && (
                  <p className="font-normal dark:text-gray-400 text-base leading-6 text-gray-600 mt-2 w-11/12">
                    {faq.content}
                  </p>
                )}
                <hr className="my-7 bg-gray-200" />
              </div>
            ))
          ) : (
            <p className="font-normal dark:text-gray-400 text-base leading-6 text-gray-600 mt-4">
              No FAQs match your search.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};



export default Faqpage;
